import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PageBlock } from '../../../../common/services';
import {ImageBlock, TextBlock} from '../../../../common/services/page';


@Component({
  selector: 'p8-bdc-edit-text',
  templateUrl: './edit-text.component.html',
  styleUrls: ['./edit-text.component.scss']
})
export class EditTextComponent implements OnInit {
  @Input() block: PageBlock;
  @Output() blockChange: EventEmitter<TextBlock> = new EventEmitter<TextBlock>();

  formats = [
    'bold',
    'italic',
    'blockquote',
    'code-block',
    'list',
    'indent',
    'link',
  ];

  modules = {
    toolbar: [
      ['bold', 'italic'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

      ['link']                         // link and image, video
    ]
  };

  constructor() { }

  ngOnInit() {
  }

  onQuillChanged(event) {
    // console.log('event ', event);
  }
}
